import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ProfilePageRoutingModule } from './profile-page-routing.module';
import { ProfilePageComponent } from './profile-page/profile-page.component';
import { UserModule } from 'libs/portal/src/modules/home/components/user/user.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '@huge-monorepo/shared/modules';
import { ToolsModule } from 'libs/portal/src/modules/tools/tools.module';
import { MatColComponent } from 'libs/portal/src/modules/tools/mat-col/mat-col.component';
import { MatRowComponent } from 'libs/portal/src/modules/tools/mat-row/mat-row.component';
import { MatDialogModule } from '@angular/material/dialog';

@NgModule({
  declarations: [ProfilePageComponent],
  imports: [CommonModule, ProfilePageRoutingModule, UserModule, ReactiveFormsModule, FormsModule, MaterialModule, ToolsModule, MatColComponent, MatRowComponent],
})
export class ProfilePageModule {}
